import { render, staticRenderFns } from "./newsPageInnovate.vue?vue&type=template&id=16517672&"
import script from "./newsPageInnovate.vue?vue&type=script&lang=js&"
export * from "./newsPageInnovate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports